/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Type of a wallet.
 *
 * @remarks
 *   - `default`: The system-generated wallet automatically created when an account is granted the wallet capability.
 *   - `general`: An additional, user-defined wallet created via API or Dashboard.
 */
export const WalletType = {
  Default: "default",
  General: "general",
} as const;
/**
 * Type of a wallet.
 *
 * @remarks
 *   - `default`: The system-generated wallet automatically created when an account is granted the wallet capability.
 *   - `general`: An additional, user-defined wallet created via API or Dashboard.
 */
export type WalletType = ClosedEnum<typeof WalletType>;

/** @internal */
export const WalletType$inboundSchema: z.ZodNativeEnum<typeof WalletType> = z
  .nativeEnum(WalletType);
/** @internal */
export const WalletType$outboundSchema: z.ZodNativeEnum<typeof WalletType> =
  WalletType$inboundSchema;
